module.exports = __webpack_public_path__ + "img/ic_inbox.041276c0.svg";